import { SiteConfig } from '@sorpetaler/ui/src/context/SiteConfigContext';

// German site configuration, injected into @sorpetaler/ui via SiteConfigProvider
// (see wrap-with-metrica-provider). Values mirror the literals that previously
// lived inside the shared components, so DE output is unchanged.
export const deSiteConfig: SiteConfig = {
  locale: 'De',
  baseUrl: 'https://www.sorpetaler.de',
  brand: {
    legalName: 'Sorpetaler Fensterbau GmbH',
    phone: {
      display: '+49 2393 9192 0',
      href: 'tel:+49 2393 9192 0',
      localHref: 'tel:0239391920',
    },
    socialLinks: [
      { title: 'Pinterest', url: 'https://www.pinterest.de/sorpetaler/' },
      { title: 'Youtube', url: 'https://www.youtube.com/c/Sorpetaler/' },
      {
        title: 'Instagram',
        url: 'https://www.instagram.com/sorpetaler_fenster/?hl=de',
      },
    ],
  },
  metricaUrl: 'https://metrica.sorpetaler.de:900/Metrica',
  breadcrumbLabels: {
    fenster: 'Fenster',
    tueren: 'Türen',
    windows: 'Windows',
    doors: 'Doors',
    'fuer-profis': 'Für Profis',
    'technik-und-systeme': 'Technik und Systeme',
    'tf-gracil': 'TF Gracil',
  },
  routePrefix: (language) => (language === 'De' ? '/' : '/en/'),
  categorySlugs: {
    references: ['referenzen', 'references'],
    fuerProfis: ['fuer-profis'],
  },
};
